export const attributesSelector = state => state.attributes;
